import { stack, hstack, css, flex } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../common';
import { HiddenMobile } from '../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { HiddenDesktop } from '../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenDesktop/HiddenDesktop';

const AssetOverviewSkeleton = () => (
  <div
    className={stack({
      gap: 'small',
      paddingX: 'medium',
      paddingY: 'large',
      width: '100%',
    })}
    data-testid="portfolio-overview-skeleton-container"
  >
    <SkeletonElement
      width="193px"
      height="32px"
      borderRadius="16px"
      testId="portfolio-overview-skeleton-title"
    />
    <div className={hstack({ justifyContent: 'space-between' })}>
      <div
        className={stack({ gap: 'small' })}
        data-testid="portfolio-overview-skeleton-left"
      >
        <SkeletonElement width="62px" height="14px" borderRadius="30px" />
        <SkeletonElement width="104px" height="14px" borderRadius="30px" />
      </div>
      <div
        className={stack({ gap: 'small' })}
        data-testid="portfolio-overview-skeleton-right"
      >
        <div className={hstack()}>
          <SkeletonElement width="62px" height="14px" borderRadius="30px" />
          <SkeletonElement width="52px" height="14px" borderRadius="30px" />
        </div>
        <div className={hstack()}>
          <SkeletonElement width="62px" height="14px" borderRadius="30px" />
          <SkeletonElement width="52px" height="14px" borderRadius="30px" />
        </div>
      </div>
    </div>
  </div>
);

const Breadcrumbs = () => (
  <div
    className={flex({
      gap: 'medium',
      paddingX: 'medium',
      paddingY: 'medium',
    })}
  >
    <SkeletonElement width="24px" height="24px" borderRadius="30px" />

    <div className={flex({ gap: 'medium' })}>
      <SkeletonElement width="50px" height="22px" borderRadius="30px" />
      <SkeletonElement width="100px" height="22px" borderRadius="30px" />
    </div>
  </div>
);

const Asset = () => (
  <div
    className={css({
      paddingX: 'medium',
      display: 'flex',
      flexDirection: 'row',
      gap: 'extra_small_2',
      justifyContent: 'space-between',
    })}
  >
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'extra_small_2',
      })}
    >
      <SkeletonElement width="30px" height="12px" />

      <SkeletonElement width="150px" height="25px" />

      <div
        className={css({
          display: 'flex',
          gap: 'extra_small_2',
        })}
      >
        <SkeletonElement width="30px" height="18px" />
        <SkeletonElement width="10px" height="18px" />
      </div>
    </div>

    <SkeletonElement width="40px" height="40px" borderRadius="50%" />
  </div>
);

const AssetStatsSkeleton = () => (
  <>
    <div
      className={stack({
        gap: 'large',
        paddingX: 'medium',
        paddingY: 'large',
        width: '100%',
      })}
      data-testid="asset-stats-skeleton-container"
    >
      <div
        className={hstack({
          justifyContent: 'space-between',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="80px" height="25px" />

          <div
            className={css({
              display: 'flex',
              gap: 'extra_small_2',
            })}
          >
            <SkeletonElement width="120px" height="18px" />
          </div>
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="80px" height="25px" />

          <div
            className={css({
              display: 'flex',
              gap: 'extra_small_2',
            })}
          >
            <SkeletonElement width="120px" height="18px" />
          </div>
        </div>
      </div>
      <div
        className={hstack({
          justifyContent: 'space-between',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="80px" height="25px" />

          <div
            className={css({
              display: 'flex',
              gap: 'extra_small_2',
            })}
          >
            <SkeletonElement width="120px" height="18px" />
          </div>
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="80px" height="25px" />

          <div
            className={css({
              display: 'flex',
              gap: 'extra_small_2',
            })}
          >
            <SkeletonElement width="120px" height="18px" />
          </div>
        </div>
      </div>

      <div
        className={hstack({
          justifyContent: 'space-between',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="70px" height="12px" />

          <SkeletonElement width="70px" height="12px" />

          <SkeletonElement width="70px" height="12px" />
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="40px" height="12px" />
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="70px" height="12px" />

          <SkeletonElement width="70px" height="12px" />

          <SkeletonElement width="70px" height="12px" />
        </div>

        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="40px" height="12px" />

          <SkeletonElement width="40px" height="12px" />
        </div>
      </div>
    </div>
  </>
);

const AssetsCTAButtonsSkeleton = () => (
  <div
    className={hstack({
      gap: 'medium',
      paddingX: 'medium',
      paddingY: 'medium',
      border: '1px solid',
      borderColor: 'neutrals.fill_focused',
      height: '92px',
    })}
    data-testid="asset-cta-buttons-skeleton-container"
  >
    <SkeletonElement
      width="100%"
      height="92px"
      className={css({
        backgroundColor: 'neutrals.card_fill_primary',
        height: '92px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <div
        className={hstack({
          gap: 'medium',
        })}
        data-testid="asset-cta-buttons-skeleton-container"
      >
        <SkeletonElement width="120px" height="40px" />
        <SkeletonElement width="120px" height="40px" />
        <SkeletonElement width="40px" height="40px" borderRadius="50%" />
      </div>
    </SkeletonElement>
  </div>
);

export const AssetDetailsHeaderSkeleton = () => (
  <>
    <HiddenMobile
      className={css({
        width: '100%',
      })}
    >
      <div
        className={css({
          width: '100%',
          display: 'flex',
          gap: 'extra_small_3',
          p: 'medium',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="30px" height="12px" />
          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: 'extra_small_2',
            })}
          >
            <SkeletonElement width="90px" height="30px" />
            <SkeletonElement width="30px" height="18px" />
          </div>
        </div>
        <SkeletonElement width="48" height="48" borderRadius="50%" />
      </div>
      <SkeletonElement
        width="100%"
        height="500px"
        className={css({
          backgroundColor: 'neutrals.card_fill_primary',
          height: '500px',
          border: '1px solid',
          borderColor: 'neutrals.fill_focused',
        })}
      />
      <AssetOverviewSkeleton />
    </HiddenMobile>

    <HiddenDesktop className={css({ width: '100%' })}>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'extra_small',
          width: '100%',
        })}
      >
        <Breadcrumbs />

        <Asset />

        <SkeletonElement
          width="100%"
          height="325px"
          className={css({
            backgroundColor: 'neutrals.card_fill_primary',
            height: '325px',
            border: '1px solid',
            borderColor: 'neutrals.fill_focused',
          })}
        />

        <AssetStatsSkeleton />

        <AssetsCTAButtonsSkeleton />
      </div>
    </HiddenDesktop>
  </>
);
